import React from 'react';
import { createRoot } from 'react-dom/client';
import { isWeChatBrowser } from '@mixonline/contracts';
import { WechatNotice } from './components/WechatNotice';
import './styles.css';

const root = createRoot(document.getElementById('root')!);
if (isWeChatBrowser(navigator.userAgent)) {
  root.render(<React.StrictMode><WechatNotice /></React.StrictMode>);
} else {
  void import('./App').then(({ App }) => root.render(<React.StrictMode><App /></React.StrictMode>));
}
